import React, { useState } from "react";

/**
 * Modale "Partager à ton personnel" : affiche le lien public d'horaire publié.
 * Extracted from pages/EventDetail.jsx (refactor Feb 27, 2026).
 */
export default function ShareModal({ event, onClose }) {
  const url = `${window.location.origin}/horaire/${event.id}`;
  const [copied, setCopied] = useState(false);
  const copy = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="fixed inset-0 z-[90] bg-black/65 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-[var(--surface)] border border-[var(--border-strong)] rounded-2xl p-6 max-w-lg w-full shadow-2xl" data-testid="share-modal">
        <div className="label mb-1">Lien horaire</div>
        <h3 className="font-serif text-3xl mb-3">Partager à ton personnel</h3>
        {!event.published_at ? (
          <p className="border-2 border-black p-3 text-xs bg-conflict-stripes-light mb-4">
            ⚠ L&apos;horaire n&apos;a pas encore été publié. Publie-le d&apos;abord pour qu&apos;il soit accessible.
          </p>
        ) : (
          <p className="text-xs text-[var(--muted)] mb-4 leading-relaxed">
            Envoie ce lien à tes officiels. Chacun entrera son nom et verra uniquement ses parties.
          </p>
        )}
        <div className="border border-black p-3 flex items-center justify-between gap-2 mb-4">
          <span className="font-mono text-xs truncate">{url}</span>
          <button onClick={copy} className="btn-secondary !px-3 !py-1.5" data-testid="copy-link-btn">
            {copied ? "Copié!" : "Copier"}
          </button>
        </div>
        <div className="flex justify-end">
          <button onClick={onClose} className="btn-primary">
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
}
